import { render, staticRenderFns } from "./TipsList.vue?vue&type=template&id=5e905c4b&"
import script from "./TipsList.vue?vue&type=script&lang=js&"
export * from "./TipsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports